import { useEffect } from 'react';
import { WEBSOCKET_DELAY_RECONNECT } from '../constants/settings';
import { Stomp } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

const TOPIC_WEBSOCKET_SED = '/topic/sed';

export default function useWebSocket(webSocketUrl, messageHandler, statusHandler) {

  const stompConfig = {
    // Keep it off for production, it can be quit verbose
    // Skip this key to disable
    debug(str) {
      //console.log(str);
    },

    // If disconnected, it will retry after delay
    reconnectDelay: Number(WEBSOCKET_DELAY_RECONNECT ? WEBSOCKET_DELAY_RECONNECT : 3000),
  };

  useEffect(() => {
    const stompClient = Stomp.over(() => {
      return new SockJS(webSocketUrl);
    });
    stompClient.configure(stompConfig);

    // Subscriptions should be done inside onConnect as those need to reinstated when the broker reconnects
    stompClient.onConnect = () => {
      stompClient.subscribe(TOPIC_WEBSOCKET_SED, message => {
        messageHandler(JSON.parse(message.body));
      });
      statusHandler(true);
    };
    stompClient.onWebSocketError = () => {
      statusHandler(false);
    };
    stompClient.onWebSocketClose = () => {
      statusHandler(false);
    };

    stompClient.activate();
    return () => {
      stompClient.deactivate();
    };
  }, []);

}